document.addEventListener("DOMContentLoaded", function(event) {
    let anchorArray = document.getElementsByTagName("a");
    const hostRegex = new RegExp("hyland.com|onbase.com|communitylive.com|alfresco.com|nuxeo.com|lawlogix.com|careers-hyland.icims.com");

    for (var i = 0; i < anchorArray.length; i++) {
        if(!hostRegex.test(anchorArray[i].host) && !anchorArray[i].href.startsWith("tel:")) {
            if (anchorArray[i].rel.length == 0) {
                anchorArray[i].rel = "noopener noreferrer";
            } else if (!anchorArray[i].rel.includes("noopener noreferrer")) {
                anchorArray[i].rel += " noopener noreferrer";
            }
        }
    }
});